module.exports = __webpack_public_path__ + "static/Mongo-67147cf9fb7d514de98afd5fc376fc92.svg";